import React, { Component } from 'react'
import ResourceService from '../../services/resource.service';

export class Invoice extends React.Component {

    constructor(props) {
        super(props)
        this.loadCss();

        this.state = {
            invoiceId :   this.props.match.params.invoiceId,
            invoice : {},
            username : localStorage.getItem("firstName") +" "+localStorage.getItem("lastName"),
            email : localStorage.getItem("email")
        }
    }

    componentDidMount() {
        this.getInvoiceDetails();
    }

    getInvoiceDetails() {
        ResourceService.getInvoiceDetails(this.state.invoiceId).then(data =>{
           // console.log(data)
            data.invoicedate = this.formatDate(data.invoicedate)
            this.setState({
                invoice : data,
            })
        }).catch(err =>{
            console.log(err)
           this.props.history.push("/error")
        })        
    }

    formatDate(inputDate) {
        var date = new Date(inputDate);
        if (!isNaN(date.getTime())) {
            var day = date.getDate().toString();
            var month = (date.getMonth() + 1).toString();
            // Months use 0 index.

            return (month[1] ? month : '0' + month[0]) + '/' +
            (day[1] ? day : '0' + day[0]) + '/' + 
            date.getFullYear();
        }
    }
    
    loadCss() {
        const link = document.createElement("link")
        link.href = "https://www.idrivecompute.com/webapp/css/invoice_transaction.css"
        link.rel = "stylesheet"
        document.head.appendChild(link)
    }
    render() {
        return (
            <body className="invoice_transaction invoice">
                <main>
                    <div className="main_container">
                        <section className="main_section">
                            <div className="main_body_container">
                                <section className="transaction_wrapper">
                                    <div className="invoice billing">
                                        <div className="billing_head">
                                            <div className="logo">
                                                {/* <div className="icon"></div> */}
                                                <img src="https://www.idrivecompute.com/webapp/images/logo_for_whiteBg.svg" alt="IDrive Compute"></img>
                                            </div>
                                            <div className="billing_history">
                                                <div className="header_title">Invoice</div>
                                                <div className="print_transaction_summary"> 
                                                    <a className="print">
                                                        <span className="pts_icon"></span> 
                                                        <span className="pts_title"onClick={() => window.print()}>Print</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="invoice_mirror_address">
                                            <p>IDrive Inc.<br/>
                                                26115, Mureau Road, Suite A,<br/>
                                                Calabasas, CA 91302.<br/>
                                                Tax ID: 95-4527848
                                            </p>
                                        </div>
                                        <div className="invoice_bill_ship_wrap">
                                            <div className="bill_ship_item">
                                                <div className="bill_ship_item_head fw_bold"> Bill To </div>
                                                <div className="bill_ship_item_body">
                                                    <p> {this.state.username}<br/>
                                                        {this.state.invoice.billingaddress}<br/>
                                                        {this.state.invoice.zipcode} 
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="bill_ship_item" style={{ display: 'none' }}>
                                                <div className="bill_ship_item_head fw_bold"> Pay To </div>
                                                <div className="bill_ship_item_body">
                                                    <p> John Adams<br/>
                                                        {this.state.invoice.billingaddress}<br/>
                                                        123122 
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="invoice_transaction_details">
                                            <div className="invoice_transaction_details_head">
                                                <div className="td_details fw_bold"> Transaction Details </div>
                                                <div className="td_description fw_bold">Description</div>
                                                <div className="td_amount fw_bold">Amount Charged</div>
                                            </div>
                                            <div className="invoice_transaction_details_body">
                                                <div className="td_item">
                                                    <div className="td_details">
                                                        <p> <span className="text_bold">Date:</span> <span>{this.state.invoice.invoicedate}</span> </p>
                                                        <p> <span className="text_bold">Card Number:</span> <span>************{this.state.invoice.last4digits}</span> </p>
                                                    </div>
                                                    <div className="td_description">
                                                        <p> <span className="text_bold">Username:</span> <span>{this.state.email}</span> </p>
                                                        {/* <p> <span>Current Plan:</span> <span>IDrive Compute Personal Yearly</span> </p>  */}
                                                        <p> <span className="text_bold">Comments:</span> <span>{this.state.invoice.comments}</span> </p>
                                                    </div>
                                                    <div className="td_amount"> ${this.state.invoice.totalamount} </div>
                                                </div>
                                            </div>
                                            <div className="invoice_transaction_details_foot">
                                                <div className="td_foot_thanks"> We appreciate your business. </div>
                                                <div className="td_foot_amount"> <span className="fw_bold">Total </span> <span> ${this.state.invoice.totalamount}</span> </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </section>
                    </div>
                </main>
            </body>
        )
    }
}

export default Invoice
